import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography,
    FormControl,
    Tooltip,
    Alert,
    Select,
    MenuItem
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
} from "chart.js";
import { ApiService } from "../../ApiService";
import { SelectBranchs } from '../../../components';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, ChartTooltip, Legend);

export const GlobalGraphics = ({ currentBranch, dataFrom, valueType = 'decimal', sellers = false, convertPrice = (() => { }) }) => {
    const [objTotalsYear, setObjTotalsYear] = useState({});
    const [objTotalsWeek, setObjTotalsWeek] = useState({});

    const [listUsers, setListUsers] = useState([]);
    const [selectedUser, setSelecteduser] = useState(null);

    const fecth_listWorkers = async (key_branch) => {
        const url = `api/company/workers/list?key_branch=${key_branch}`;
        const options = { method: 'GET' };

        const request_users = await ApiService.fetchData(url, options);

        if (!request_users) {
            alert('Error al cargar los datos de trabajadores');
            return;
        }

        setListUsers(request_users);

        return request_users[0] ? request_users[0].key : null;
    };

    const fetch_saleTotals = async (name, key_branch, key_user = null) => {
        const url = `api/company/sale/list-${name}?type=${dataFrom}&key_branch=${key_branch + (sellers ? ('&key_sp=' + key_user) : '')}`;
        const options = { method: "GET" };

        const request_totals = await ApiService.fetchData(url, options);

        if (!request_totals) {
            alert("Error al cargar los datos de venta");
            return;
        }

        name === "year" ? setObjTotalsYear(request_totals) : setObjTotalsWeek(request_totals);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (currentBranch?.key_branch) {
                const key_branch = currentBranch.key_branch;
                let user_key = null;

                if (sellers) {
                    user_key = await fecth_listWorkers(key_branch);
                    setSelecteduser(user_key);
                }

                fetch_saleTotals('year', key_branch, user_key);
                fetch_saleTotals('week', key_branch, user_key);
            }
        };

        fetchData();
    }, [currentBranch, dataFrom]);

    const handleChangeUser = (event) => {
        setSelecteduser(event);

        const key_branch = currentBranch?.key_branch;
        fetch_saleTotals('year', key_branch, event);
        fetch_saleTotals('week', key_branch, event);
    };

    const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];
    const sales =
        objTotalsYear &&
        months.map((text) => {
            return valueType == 'decimal' ? parseFloat(objTotalsYear[text]).toFixed(2) : Number(objTotalsYear[text]);
        });

    const days = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"];
    const weeklySales =
        objTotalsWeek &&
        days.map((text) => {
            return valueType == 'decimal' ? parseFloat(objTotalsWeek[text]).toFixed(2) : Number(objTotalsWeek[text]);
        });

    // Datos para la gráfica semanal
    const weeklyData = {
        labels: days,
        datasets: [
            {
                label: `Ventas por día (${currentBranch?.currency})`,
                data: weeklySales,
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
            },
        ],
    };

    // Datos para la gráfica anual
    const data = {
        labels: months,
        datasets: [
            {
                label: `Ventas por mes (${currentBranch?.currency})`,
                data: sales,
                backgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56",
                    "#4BC0C0",
                    "#9966FF",
                    "#FF9F40",
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56",
                    "#4BC0C0",
                    "#9966FF",
                    "#FF9F40",
                ],
            },
        ],
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '1rem 10px 1rem 10px' }}>
            <div>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', gap: '5px', marginBottom: '5px' }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Ventas del Año
                    </Typography>

                    <div className="selects-company">
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                            <SelectBranchs />
                        </FormControl>
                        &nbsp;
                        {
                            sellers && (
                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <Select
                                        labelId="store-select-label"
                                        value={selectedUser && selectedUser}
                                        onChange={(item) => { handleChangeUser(item.target.value) }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: {
                                                sx: {
                                                    zIndex: 1,
                                                },
                                            },
                                        }}
                                    >
                                        {//aqui
                                            listUsers && listUsers.map((user, index) => {
                                                return (
                                                    <MenuItem key={user.key} value={user.key}>{user.name}</MenuItem>
                                                );
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }
                    </div>
                </div>


                <div className="graficos-company">
                    <Grid item xs={12} md={3} sx={{ height: "100%" }}>
                        <TableContainer component={Paper} sx={{ height: "100%" }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <b>Mes</b>
                                        </TableCell>
                                        <TableCell align="right">
                                            <b>Ventas ({currentBranch?.currency})</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {months.map((month, index) => (
                                        <TableRow key={month}>
                                            <TableCell>{month}</TableCell>
                                            <TableCell align="right">{dataFrom != "number" ? convertPrice(sales[index], null, true) : sales[index]}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Paper elevation={3} sx={{ p: 2, height: "100%" }}>
                        <Box sx={{ height: "100%", Width: '100%' }}>
                            <Bar data={data} style={{ minWidth: '100%' }} />
                        </Box>
                    </Paper>
                </div>
            </div>


            <div>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Ventas de la Semana
                </Typography>

                <div className="graficos-company">
                    <Grid item xs={12} md={3} sx={{ height: "100%" }}>
                        <TableContainer component={Paper} sx={{ height: "100%" }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <b>Día</b>
                                        </TableCell>
                                        <TableCell align="right">
                                            <b>Ventas ({currentBranch?.currency})</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {days.map((day, index) => (
                                        <TableRow key={day}>
                                            <TableCell>{day}</TableCell>
                                            <TableCell align="right">{dataFrom != "number" ? convertPrice(weeklySales[index], null, true) : weeklySales[index]}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Paper elevation={3} sx={{ p: 2, height: "100%" }}>
                        <Box sx={{ height: "100%", Width: '100%' }}>
                            <Bar data={weeklyData} style={{ minWidth: '100%' }} />
                        </Box>
                    </Paper>
                </div>
            </div>
        </div >
    );
};

export default GlobalGraphics;
